export const lotties = {
  emptyFolder: 'https://s3.kornet.uz/chat-files/243c3f130fe09e33bcdf2ef696f85e11',
  xMark: 'https://s3.kornet.uz/chat-files/e59d6a967c81aed2bfc2460e88933592',
  lock: 'https://s3.kornet.uz/chat-files/0b078fed321e90006eedcbc78932c3c6',
  gift: 'https://s3.kornet.uz/chat-files/0d3b8e9d79af7e9a220551e18aeacd39',
  like: 'https://s3.kornet.uz/chat-files/a762535bcbf7de4bc2da372ebfe50d0f',
  comment: 'https://s3.kornet.uz/chat-files/e7c06680f231a0f4d049aa2d04c7d720',
  magnificationGlass: 'https://s3.kornet.uz/chat-files/b4bfaf84c4b3481db5ee05a0d4b61a11',
  boomstick: 'https://s3.kornet.uz/chat-files/d80638d61c680f13284296e053dacf75',
  folder: 'https://s3.kornet.uz/chat-files/82f0bccef0917861e0ee8cb597ef8e3e',
  boomsphere: 'https://s3.kornet.uz/chat-files/e0c1feaaf59f7c7e4da8f5c2f082c0b9',
  stick: 'https://s3.kornet.uz/prod-chat-bucket/7cbf4549887979894cb0bbf6bceeb959',
};
